import { APP_MAIN_URL } from '../saas/AppStorageStaticNames';
import {
  getStringFromLS,
  getValueFromAppConfig,
} from '../shared/helper-utils/localStorage';
import { doPostWithoutSessionToken } from './apiUtils';

export const addAgentApi = async (req) => {
  try {
    const request = {
      opid: 'MU025',
      actioncode: 'ADDANONYMOUSV3',
      registerrequest: JSON.stringify({
        userregisterrequest: req,
      }),
    };
    const response = await doPostWithoutSessionToken(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getCitiesforRegistration = async () => {
  try {
    const request = {
      opid: 'GENERIC',
      actioncode: 'SEARCHCITIES',
      country: getValueFromAppConfig('SAAS_HOTEL_PAX_COUNTRY'),
      resultformat: 'JSON',
    };
    const response = await doPostWithoutSessionToken(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const sendMobileRegistrationOtpApi = async (mobileNumber) => {
  try {
    const request = {
      opid: 'MU025',
      actioncode: 'SENDREGISTRATIONOTP',
      mobilenumber: mobileNumber,
    };
    const response = await doPostWithoutSessionToken(request);
    return response;
  } catch (err) {
    return undefined;
  }
};

export const sendRegistrationOtpApi = async (mobileNumber, emailId) => {
  try {
    const request = {
      opid: 'MU025',
      actioncode: 'SENDREGISTRATIONOTP',
      mobilenumber: mobileNumber,
      emailid: emailId,
    };
    const response = await doPostWithoutSessionToken(request);
    return response;
  } catch (err) {
    return undefined;
  }
};

export const verifyRegistrationOtpApi = async (req) => {
  try {
    const request = {
      opid: 'MU025',
      actioncode: 'VERIFYREGISTRATIONOTP',
      ...req,
    };
    const response = await doPostWithoutSessionToken(request);
    return response;
  } catch (err) {
    return undefined;
  }
};

export const uploadImageForRegistration = async (obj) => {
  const API_PATH = getStringFromLS(APP_MAIN_URL);
  const url = `${API_PATH}s3fileupload.jsp?resultformat=JSON`;
  try {
    const res = await fetch(url, {
      method: 'post',
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
      body: obj,
    });
    if (res) {
      return res;
    }
    const response = await res.json();
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getMobileOtpForRegistrationApi = async (mobile) => {
  try {
    const request = {
      opid: 'MU025',
      actioncode: 'SENDREGISTRATIONOTP',
      // emailid: email,
      mobilenumber: mobile,
    };
    const response = await doPostWithoutSessionToken(request);
    return response;
  } catch (err) {
    return undefined;
  }
};

export const verifyMobileOtpForRegistrationApi = async (mobile, otp) => {
  try {
    const request = {
      opid: 'MU025',
      actioncode: 'VERIFYREGISTRATIONOTP',
      mobilenumber: mobile,
      mobileotp: otp,
    };
    const response = await doPostWithoutSessionToken(request);
    return response;
  } catch (err) {
    return undefined;
  }
};

export const verifyDocumentNumberApi = async (
  docnumber,
  doctype,
  otp,
  requestid,
) => {
  try {
    const request = {
      opid: 'GENERIC',
      actioncode: 'VERIFYREGISTRATIONDOCUMENTNUMBERS',
      resultformat: 'JSON',
      docnumber,
      doctype,
      otp,
      requestid,
    };
    const response = await doPostWithoutSessionToken(request);
    return response;
  } catch (err) {
    return undefined;
  }
};
